<template>
  <b-modal
    v-model="dataModal"
    centered
    no-close-on-backdrop
    no-close-on-esc
    title="Edit Project"
    @close="onCloseModal">
    <div class="model-project-settings">
      <call-input
        v-model="$v.dataForm.name.$model"
        type-input="text"
        :valide="$v.dataForm.name.$error"
        float-name-label="Name" />
    </div>
    <template #modal-footer>
      <call-button
        :icon="dataCloseIcon"
        type="danger"
        plain
        @click="onCloseModal()">
        Cancel
      </call-button>
      <call-button
        :disabled="$v.$invalid"
        type="success"
        @click="clickAdd()">
        Edit
      </call-button>
    </template>
  </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue';
import { faPlay } from '@fortawesome/pro-regular-svg-icons';

import CallButton from '../CallButton';
import { validationMixin } from 'vuelidate';
import {
  PROJECTS_PATCH
} from '../../../store/types/actions.types';
import iconsModal from '../../../mixins/iconsModal';
import { required } from 'vuelidate/lib/validators';
import CallInput from '../CallInput';

export default {
  name: 'CallUpdateNameProject',
  components: {
    CallButton,
    BModal,
    CallInput
  },
  mixins: [validationMixin, iconsModal],
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dataIconPlay: faPlay,
      dataModal: this.value,
      dataForm: {
        name: ''
      }
    };
  },
  validations: {
    dataForm: {
      name: {
        required
      }
    }
  },

  watch: {
    async value () {
      this.dataModal = this.value;
      this.setEditParams();
    }
  },

  methods: {
    setEditParams (paramsSettings) {
      const name = this.$route.query?.projectName || '';

      this.$nextTick(() => {
        this.$set(this.dataForm, 'name', name);
      });
    },

    onCloseModal () {
      this.$emit('input', false);
    },
    async clickAdd () {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }
      try {
        const id = this.$route.params.projectId;
        const params = {
          name: this.dataForm.name
        };

        await this.$store.dispatch(`project/${PROJECTS_PATCH}`, {
          id,
          params,
          context: this
        });

        const query = { ...this.$route.query, projectName: this.dataForm.name };
        this.$router.replace({ query });

        this.onCloseModal();
        this.$emit('on-update');
      } catch (e) {
        throw Error(e);
      }
    }
  }
};
</script>

<style lang="scss">
.model-project-settings {
  .upload__title {
    margin-bottom: 16px;
  }
  .wrapper-select-period {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    .vs__selected {
      margin: 0 !important;
    }

    input {
      height: 25px;
    }

  }
  .call-input {
    margin-bottom: 16px;
  }

  .call-input input {
    height: 26px !important;
  }
}

</style>
